/* Craft's MenuDrawer binds a click handler to every <summary> inside <header-drawer>
   and treats the next sibling as a full-screen sliding submenu: it adds .menu-opening,
   sets .submenu-open on the parent and traps focus inside the panel. Our sections are
   accordions that open in place, so that behaviour is wrong for them.

   Keeping MenuDrawer out means stopping the click before it reaches the summary's own
   listener, and a capture-phase listener on the document is the only place early enough.
   But halting dispatch there also stops the summary from ever receiving the event, and
   Chrome performs the native <details> toggle in the summary's own default event
   handler. So the toggle never happens unless we do it ourselves. We do it here.

   The hamburger summary is not matched, so opening and closing the drawer is untouched.
   Enter and Space on a focused summary both dispatch a click, so keyboard use still works. */
(function () {
  document.addEventListener(
    'click',
    function (event) {
      const target = event.target;
      if (!target || !target.closest) return;
      const summary = target.closest('summary.brs-drawer__head');
      if (!summary) return;
      const details = summary.parentNode;
      if (!details || details.tagName !== 'DETAILS') return;

      event.preventDefault();
      event.stopPropagation();
      details.open = !details.open;
    },
    true
  );

  /* One section open at a time, so the drawer never turns into a long scroll. */
  document.addEventListener(
    'toggle',
    function (event) {
      const opened = event.target;
      if (!opened || !opened.matches) return;
      if (!opened.matches('details.brs-drawer__section') || !opened.open) return;

      const scope = opened.closest('.brs-drawer');
      if (!scope) return;
      scope.querySelectorAll('details.brs-drawer__section[open]').forEach(function (other) {
        if (other !== opened) other.open = false;
      });

      /* Bring the section head to the top of the drawer's scroll area.
         The scroller is .menu-drawer__navigation-container, which Craft gives
         height 100% and overflow-y auto. Neither #menu-drawer nor the inner
         container scrolls, so scrolling those does nothing. */
      const head = opened.querySelector('summary.brs-drawer__head');
      const scroller = opened.closest('.menu-drawer__navigation-container');
      if (!head || !scroller || typeof scroller.scrollTo !== 'function') return;
      const delta = head.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
      scroller.scrollTo({ top: scroller.scrollTop + delta, behavior: 'smooth' });
    },
    true
  );
})();
